/**
 * Submit Content Report UseCase
 *
 * Submits a content report via ReportService.
 *
 * Pattern from Flutter: ReportRepository.reportContent
 * Source: lib/data/repository/report_repository.dart
 */

import { reportService } from '@/domain/services/report/reportService';

export class SubmitContentReportUseCase {
  /**
   * Submit a report against a piece of content
   *
   * @param reportItemId - ID of the selected ContentReportItem (leaf item)
   * @param contentId - ID of the reported content
   * @param peerUserId - Firebase ID of the content owner
   * @param comment - Optional free text comment (max 200 chars)
   * @returns Promise<boolean> - Success status
   */
  async execute(
    reportItemId: string,
    contentId: string,
    peerUserId: string,
    comment: string
  ): Promise<boolean> {
    return reportService.submitContentReport(reportItemId, contentId, peerUserId, comment);
  }
}

export const submitContentReportUseCase = new SubmitContentReportUseCase();
